import { apiService } from './api';

export type GraphNode = {
  id: string;
  type: 'stakeholder' | 'organization';
  label: string;
};

export type GraphLink = {
  source: string;
  target: string;
  type: 'os' | 'oo' | 'ss';
  weight?: number;
  label?: string;
  id?: string;
  custom?: boolean;
  category?: string;
};

export type GraphData = {
  nodes: GraphNode[];
  links: GraphLink[];
};

export async function fetchGraph(params: {
  currentOnly?: boolean;
  stakeholderId?: string;
  organizationId?: string;
} = {}): Promise<GraphData> {
  const search = new URLSearchParams();
  if (params.currentOnly !== undefined) search.set('currentOnly', String(params.currentOnly));
  if (params.stakeholderId) search.set('stakeholderId', params.stakeholderId);
  if (params.organizationId) search.set('organizationId', params.organizationId);

  const qs = search.toString();
  const url = `/api/relationships/graph${qs ? `?${qs}` : ''}`;
  const res = await apiService.get<GraphData>(url);
  return res.data;
}

export async function createRelationship(payload: {
  sourceType: 'stakeholder' | 'organization';
  sourceId: string;
  targetType: 'stakeholder' | 'organization';
  targetId: string;
  type?: 'ss' | 'oo' | 'os';
  label?: string;
  description?: string;
  category?: string;
  weight?: number;
  startDate?: string;
  endDate?: string;
}) {
  const body: any = { ...payload };
  // Normalize type based on endpoints if not provided
  if (!body.type) {
    body.type = body.sourceType === 'organization' && body.targetType === 'organization' ? 'oo'
      : body.sourceType === 'stakeholder' && body.targetType === 'stakeholder' ? 'ss'
      : 'os';
  }
  const res = await apiService.post('/api/relationships', body);
  return res.data;
}

export async function updateRelationship(id: string, payload: Partial<{
  type: 'ss' | 'oo' | 'os';
  label: string;
  description: string;
  category: string;
  weight: number;
  startDate: string;
  endDate: string | null;
}>) {
  const res = await apiService.patch(`/api/relationships/${id}`, payload);
  return res.data;
}

export async function deleteRelationship(id: string) {
  const res = await apiService.delete(`/api/relationships/${id}`);
  return res.data;
}
